<script>
  import Dialog from '../../Common/Dialog/Dialog.svelte';
  import EditInput from '../../Common/EditInput/EditInput.svelte';
  import Spinner from '../../Common/Spinner.svelte';
  import { selectedChannelId } from '../../../Store/store';
  import {
    updateChannelTitle,
    changeChannelStatus,
    addMapping,
    removeMappingUrl,
    listenToChannelMappingIds,
    listenToChannel,
  } from '../../../Api/playlistApi';
  import Button from '../../Common/Button.svelte';

  let isLoadingMappings = false;
  $: isCheckingUrl = false;
  let showDialog = false;
  let selected;

  $: dialogInputValue = '';
  $: $selectedChannelId && listenToMappings();
  $: $selectedChannelId && getChannelData();
  $: urls = [];

  const listenToMappings = async () => {
    isLoadingMappings = true;
    urls = [];
    await listenToChannelMappingIds((docRefs) => {
      if (!docRefs.empty) {
        const cIds = docRefs.docs.map((d) => ({ ...d.data(), id: d.id }));
        for (let i = 0; i < cIds.length; i++) {
          const c = cIds[i];
          if (c.id === $selectedChannelId) {
            urls = c.urls;
            break;
          }
        }
      }
      isLoadingMappings = false;
    });
  };

  const getChannelData = async () => {
    await listenToChannel($selectedChannelId, (snapShot) => {
      if (snapShot.exists) {
        selected = { ...snapShot.data(), id: snapShot.id };
      }
    });
  };

  const onSaveTitle = async (e) => {
    if (e.detail) {
      await updateChannelTitle($selectedChannelId, e.detail);
    }
  };

  const onshowFeedClicked = async (e) => {
    e.stopPropagation();
    await changeChannelStatus($selectedChannelId, !selected.live);
  };
  const onAddUrlClicked = async (e) => {
    e.stopPropagation();
    dialogInputValue = '';
    showDialog = true;
  };

  const onAddUrlDialogOk = async (e) => {
    isCheckingUrl = true;
    await addMapping($selectedChannelId, e.detail);
    dialogInputValue = '';
    showDialog = false;
    isCheckingUrl = false;
  };
  const onAddUrlDialogCancel = async () => {
    showDialog = false;
    isCheckingUrl = false;
  };

  const onDeleteUrlClicked = async (e, url) => {
    e.stopPropagation();
    await removeMappingUrl($selectedChannelId, url);
  };
</script>

<div class="feed-config-container">
  {#if selected}
    <div class="header">
      <div class="title">
        <EditInput value={selected.title} on:save={onSaveTitle} large={true} />
      </div>
      <div class="btn-container">
        <Button on:click={(e) => onshowFeedClicked(e)} big={true} red={selected.live}>
          {selected.live ? 'Skjul video' : 'Vis video'}
        </Button>
      </div>
    </div>
  {/if}
  <div class="url-mappings">
    <div class="header">
      <h4>URL'er hvor denne feeden skal vises</h4>
      <button class="icon-button" on:click={onAddUrlClicked}>
        <span class="material-icons primary-icon"> add_circle </span>
      </button>
    </div>
    {#if isLoadingMappings}
      <Spinner />
    {:else}
      <div class="urls">
        {#each urls as url}
          <div class="url">
            <p>{url}</p>
            <div class="btn-container">
              <button class="icon-button" on:click={(e) => onDeleteUrlClicked(e, url)}>
                <span class="material-icons"> cancel </span>
              </button>
            </div>
          </div>
        {/each}
      </div>
    {/if}
  </div>
</div>

<Dialog
  open={showDialog}
  on:cancel={onAddUrlDialogCancel}
  on:ok={onAddUrlDialogOk}
  isLoading={isCheckingUrl}
  placeholder="url"
  title="Legg til ny URL"
  inputValue={dialogInputValue}
/>

<style src="./settings.scss">
</style>
